const getters = {
    token: state => state.user.accessToken,
    userID: state => state.user.userID,
    version:state => state.user.version
}
export default getters